import { render, staticRenderFns } from "./TagListImage.vue?vue&type=template&id=89bd3b14&name=tag-list-image&"
import script from "./TagListImage.vue?vue&type=script&lang=js&"
export * from "./TagListImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports